import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import { HelpIcon } from "components/CustomIcons";
import { useState } from "react";

interface ReopenCaseDialogProps {
  showDialog: boolean;
  onReopen: (note: string) => void;
  onCancel: () => void;
}

const CHARACTER_LIMIT = 50;

const ReopenCaseDialog = (props: ReopenCaseDialogProps) => {
  const { showDialog, onReopen, onCancel } = props;
  const [reopenNote, setReopenNote] = useState("");
  return (
    <Dialog open={showDialog} maxWidth="xs" fullWidth onClose={() => onCancel()}>
      <DialogTitle
        sx={{
          display: "flex",
          gap: 0.5,
        }}>
        Reopen Case
        <Tooltip title="If provided, this reason text will be displayed below the case status">
          <HelpIcon fontSize="small" />
        </Tooltip>
      </DialogTitle>

      <DialogContent>
        <TextField
          sx={{ mt: 1 }}
          label="Reason"
          fullWidth
          value={reopenNote}
          onChange={(e) => setReopenNote(e.target.value)}
          inputProps={{
            maxLength: CHARACTER_LIMIT,
          }}
          InputProps={{
            endAdornment: <InputAdornment position="start">{`${reopenNote.length}/${CHARACTER_LIMIT}`}</InputAdornment>,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="text" onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={() => onReopen(reopenNote)}>
          Open Case
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReopenCaseDialog;
